import {
  DATA_INDEX,
  KEY,
  TITLE,
  U_ACTION,
  U_BRANCH,
  U_NAME,
  U_QUANTITY,
} from '@app/constants';
import type { WarehousesRegistryColumns } from '@app/pages/Warehouses/WarehouseRegistry/types';

import type { ColumnsType } from 'antd/es/table';

export const WAREHOUSE_REGISTRY_COLUMNS: ColumnsType<WarehousesRegistryColumns> =
  [
    {
      [TITLE]: 'Название',
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
      render: (text: string) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      [TITLE]: 'Филиалы',
      [DATA_INDEX]: U_BRANCH,
      [KEY]: U_BRANCH,
      render: (text: string) => <span className="no-wrap-text">{text}</span>,
    },
    {
      [TITLE]: 'Кол-во товара',
      [DATA_INDEX]: U_QUANTITY,
      [KEY]: U_QUANTITY,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
    },
  ];
